import { render, staticRenderFns } from "./index.vue?vue&type=template&id=31fdb10f&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=31fdb10f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31fdb10f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31fdb10f')) {
      api.createRecord('31fdb10f', component.options)
    } else {
      api.reload('31fdb10f', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=31fdb10f&scoped=true&", function () {
      api.rerender('31fdb10f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/platform-sales-fee/index.vue"
export default component.exports